import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { allZonesInfoSelector, currentClientStatusSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listAllZones } from 'redux/modules/model/site';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
    if (criteria.search) {
        const ucSearch = criteria.search.toUpperCase()
        return item.clientId.toUpperCase().includes(ucSearch) ||
            item.siteId.toUpperCase().includes(ucSearch) ||
            item.zoneId.toUpperCase().includes(ucSearch)
    }
    return true
}

class ZoneList extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        listAllZones: PropTypes.func.isRequired,
        logUserTab: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        // zonesInfo: PropTypes.array.isRequired,
        operatorListStatus: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props)
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        const { clientId, logUserTab, listAllZones } = this.props
        console.log(listAllZones({ clientId }))
        const tab = "Zone"
        logUserTab({ clientId, tab })
    }

    setURLHref = (params) => {
        const { history } = this.props
        history.push({
            location: ROUTES.DIRECTORY,
            search: jsonToQueryString(params)
        })
    };

    handleViewModeChange = (view) => {
        const { location } = this.props
        const params = {
            ...parseQueryString(location.search),
            view
        }
        this.setURLHref(params)
    };

    handleSearchChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    render() {
        const { operatorListStatus, location, allZonesList } = this.props
        const params = parseQueryString(location.search)
        const { view = 'list' } = params
        const criteria = {
            ...params,
            search: this.state.search || params.search
        }
        const filteredZones = fp.filter(predicate(criteria))(allZonesList)

        return (
            <div>
                <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
                {API_PENDING === operatorListStatus && <Spinner />}
                {API_SUCCESS === operatorListStatus && <ListView zones={filteredZones} />}
                {API_FAIL === operatorListStatus && <h2>Failed to load zones</h2>}
            </div>
        )
    }
}

export const selector = createStructuredSelector({
    operatorListStatus: currentClientStatusSelector,
    allZonesList: allZonesInfoSelector
})

export const actions = {
    listAllZones,
    logUserTab
}

export default compose(
    withRouter,
    withClientId,
    connect(selector, actions),
)(ZoneList)



// WEBPACK FOOTER //
// ./src/pages/zone/zone-list/index.js